import axios from "./axios";

class UtiPanCardService {
  ewalletGenerateUrl = async () => {
    try {
      const response = await axios.post(
        "/uti_pancard/ewallet/generate_url",
        {},
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  ewalletReport = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page,
  ) => {
    try {
      const response = await axios.post("/uti_pancard/ewallet/report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  agentOnboard = async () => {
    try {
      const response = await axios.post("/uti_pancard/agent_onboard", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  agentDetails = async () => {
    try {
      const response = await axios.post("/uti_pancard/agent_details", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  serviceStatus = async () => {
    try {
      const response = await axios.post("/uti_pancard/service_status", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchCommercial = async (quantity) => {
    try {
      const response = await axios.post("/uti_pancard/fetch_commercial", {
        quantity,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  buyCoupon = async (quantity) => {
    try {
      const response = await axios.post("/uti_pancard/buy_coupon", {
        quantity: quantity,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  history = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page,
  ) => {
    try {
      const response = await axios.post("/uti_pancard/report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  links = async () => {
    try {
      const response = await axios.post("/uti_pancard/links", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  panFindTransaction = async (aadhaar) => {
    try {
      const response = await axios.post("/uti_pancard/panfind/transaction", {
        aadhaar: aadhaar,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  panFindFetchCommercial = async () => {
    try {
      const response = await axios.post(
        "/uti_pancard/panfind/fetch_commercial",
        {},
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  panFindReport = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page,
  ) => {
    try {
      const response = await axios.post("/uti_pancard/panfind/report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new UtiPanCardService();
